var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSolaring)?_c('certification-manege-solaring'):_c('certification-manage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }